var $ = global.jQuery = global.$;

var _Base = require('./_Base');
var IconToggle = _Base.extend({
  init: function() {
    var self = this;

    this.$toggleIcon = this.$el.find('[data-icon-alt]');

    this.classes = {
      icon: this.$toggleIcon.data('icon'),
      iconAlt: this.$toggleIcon.data('iconAlt')
    };

    this.$el.on('click', function(event) {
      self.toggle();
    });

  },

  toggle: function() {
    if (this.$toggleIcon.hasClass(this.classes.icon)) {
      this.$toggleIcon.addClass(this.classes.iconAlt);
      this.$toggleIcon.removeClass(this.classes.icon);
    } else if (this.$toggleIcon.hasClass(this.classes.iconAlt)) {
      this.$toggleIcon.addClass(this.classes.icon);
      this.$toggleIcon.removeClass(this.classes.iconAlt);
    }
  }
});

module.exports = IconToggle;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/IconToggle.js
 ** module id = 153
 ** module chunks = 0 1
 **/